(window.OEVideo = function ($, Behaviors) {
    "use strict";

    const module = {};

    function OEVideo() {
        const videoSections = document.querySelectorAll('.bw-video-tabs-section');

        if (!videoSections) {return;}

        function loadVideoOnClick() {


            videoSections.forEach(section => {

                const videos = section.querySelectorAll('.bw-video');

                if (!videos) {return;}

                videos.forEach(video => {
                    if (!video.dataset.bwVideoId) {return false;}

                    const overlay = video.querySelector('.bw-video-overlay');

                    overlay.addEventListener('click', () => {
                        overlay.style.opacity = 0;

                        setTimeout(()=>{
                            overlay.style.display = 'none';
                        }, 300);

                        try {
                            const videoContainer = video.querySelector('.bw-video-container');
                            const videoId = video.dataset.bwVideoId;
                            const isWistia = video.dataset.bwVideoType === 'wistia';
                            const isYouTube = video.dataset.bwVideoType === 'youtube';
                            const isVimeo = video.dataset.bwVideoType === 'vimeo';
                            const playBtn = video.querySelector(".play-button");

                            if (isWistia) {
                                window._wq = window._wq || [];
                                _wq.push({
                                    id: videoId, // replace with your actual video ID
                                    options: { autoPlay: true },
                                    onReady: function(video) {
                                        // const playBtn = video.querySelector(".play-button");
                                        playBtn.addEventListener("click", function() {
                                            video.play();
                                        });
                                    }
                                });

                            } else if (isYouTube) {
                                const player = new YT.Player(videoContainer, {
                                    height: '100%',
                                    width: '100%',
                                    videoId: videoId,
                                    playerVars: {
                                        'controls': 1,
                                        'rel': 0
                                    },
                                    events: {
                                        'onReady': (event) => {
                                            event.target.playVideo();
                                        },
                                        'onStateChange': (event) => {
                                            // if (event.data === YT.PlayerState.PLAYING) {
                                            //     overlay.style.opacity = 0;

                                            //     setTimeout(()=>{
                                            //         overlay.style.display = 'none';
                                            //     }, 500);
                                            // }
                                        },
                                        'onError': (event) => {
                                            console.error('YouTube player error:', event);
                                        }
                                    },
                                });
                            } else if (isVimeo) {
                                const iframe = document.createElement('iframe');
                                iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&controls=1`;
                                iframe.width = '100%';
                                iframe.height = '100%';
                                iframe.style.border = 'none';
                                iframe.allow = 'autoplay; fullscreen; picture-in-picture';
                                iframe.allowFullscreen = true;
                                videoContainer.appendChild(iframe);
                            }
                        } catch (e) {
                            console.log(e);
                        }

                    });
                });
            });
        }

        loadVideoOnClick();
    }

    document.addEventListener('DOMContentLoaded', () => {
        OEVideo();
    });

    return module;

}(window.jQuery, window.Behaviors));

